exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gallery-showcase .swiper-container,\n.gallery-showcase .swiper-wrapper,\n.gallery-showcase .swiper-slide {\n  width: 100%;\n}", ""]);

// exports
